// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"_1bIk","is-open":"_2Ism","twoBlock":"_3j1_","platformDropdown":"_126L","solutionsDropdown":"_1gCd","whyDropdown":"_10Eu","developersDropdown":"_1xI2","footer-list":"_14MM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown/Dropdown.styl
// module id = 75
// module chunks = 0